import { render, staticRenderFns } from "./MasterBatanganDetail.vue?vue&type=template&id=14ec5188&scoped=true"
import script from "./MasterBatanganDetail.vue?vue&type=script&lang=js"
export * from "./MasterBatanganDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ec5188",
  null
  
)

export default component.exports